import React, { FC, useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import IssueReport from '../model';

interface PreviousReportInfoProps {
  issueReport: IssueReport;
}

const PreviousReportInfo: FC<PreviousReportInfoProps> = (props) => {
  let { issueReport } = props;

  let [fullInfoOpen, setFullInfoOpen] = useState<boolean>(false);

  return (
    <Grid
      container
      onClick={() => setFullInfoOpen(!fullInfoOpen)}
      style={{
        border: '1px solid gray',
        borderRadius: 5,
        paddingLeft: 5,
        cursor: 'pointer',
        backgroundColor: 'aliceblue',
      }}
    >
      <Grid item xs={11} md={6}>
        <Typography variant="body1">{issueReport.user_name}</Typography>
      </Grid>
      <Grid item xs={11} md={5}>
        <Typography variant="body1">{issueReport.updated_at_with_time}</Typography>
      </Grid>
      <Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}>
        <KeyboardArrowDownIcon
          style={{
            transition: 'transform 0.3s ease',
            transform: fullInfoOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </Grid>
      {fullInfoOpen && (
        <Grid item xs={12}>
          <Typography variant="body1">{issueReport.message}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default PreviousReportInfo;
